import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propShape } from '../../../../../helpers/custom-prop-types';
import { isDoneResponse } from '../../../../../helpers/professional_my_page';
const getStatus = (order) => {
    let className = '';
    let text = '';
    const { professionalStatus } = order;
    const isDoneFirst = isDoneResponse(order);
    if ([2, 3].includes(professionalStatus)) {
        className = 'is-done';
        text = '対応済';
    }
    else if (!isDoneFirst) {
        className = 'is-notrespond';
        text = '未対応';
    }
    else {
        className = 'is-doing';
        text = '対応中';
    }
    return {
        className,
        text,
    };
};
const DetailState = ({ order }) => {
    const { className, text } = getStatus(order);
    return (_jsx("div", Object.assign({ className: 'detail-state' }, { children: _jsx("div", Object.assign({ className: className }, { children: text })) })));
};
DetailState.propTypes = {
    order: propShape().isRequired,
};
export default DetailState;
